module.exports = "\n<div class=\"card\">\n  <h4>No Report Found</h4>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/report/report component/no-report/no-report.component.html
// module id = ../../../../../src/app/report/report component/no-report/no-report.component.html
// module chunks = main